module.exports = "/_next/static/images/08be26f315fd8c7f2ece0cd7beac91b7-pregnant-woman@tablet@2x.jpg.webp";